/* =========================================================================
   FLASH PROMO — CAIXAS DE COMPRA (01/10/2026)

   Só existe na PDP do "Top Basic - Flash Promo" (template product.flash-promo):
   o snippet tp-flash-promo-caixas.liquid é quem carrega este arquivo.

   Duas caixas: "1 Top Basic" (preço normal) e "2 + 1 grátis" (em destaque).
   Na caixa 2 a cliente escolhe cor e tamanho de DUAS peças; a terceira é
   escolhida no carrinho pelo pop-up (tp-flash-promo-popup.js), que abre assim
   que as duas entram. O preço mostrado é a soma das variantes escolhidas, não
   um número digitado: o carrinho cobra exatamente isso, e o desconto do
   terceiro é do admin (compre 2, ganhe 1 a 100%).

   Foto da cor: ao escolher a cor da peça 1, a galeria da página vai para a
   foto daquela cor SEM mover a janela (mesma técnica do tp-oferta-b: troca a
   classe is-active e rola só a lista de fotos).
   ========================================================================= */
(function () {
  if (window.__tpFpCaixas) return;
  window.__tpFpCaixas = true;

  var raiz = document.querySelector('[data-tp-fp]');
  var dadosEl = document.querySelector('[data-tp-fp-data]');
  if (!raiz || !dadosEl) return;
  var D;
  try { D = JSON.parse(dadosEl.textContent); } catch (e) { return; }

  var CORES_HEX = { preto: '#1a1a1a', branco: '#f3f2ee', bosque: '#3f5a3b', cereja: '#c50b39', 'café': '#7b4a2d', cafe: '#7b4a2d', 'azul marinho': '#2c3e6b', bege: '#d9c6b0', verde: '#6b7f5a', 'azul claro': '#9bb7d4' };
  var q = function (s, el) { return (el || raiz).querySelector(s); };
  var qa = function (s, el) { return [].slice.call((el || raiz).querySelectorAll(s)); };
  function brl(c) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function semAcento(s) { s = String(s || ''); return (s.normalize ? s.normalize('NFD').replace(/[̀-ͯ]/g, '') : s).toLowerCase(); }

  var ci = D.colorIndex, si = D.sizeIndex;
  function variante(cor, tam) {
    for (var i = 0; i < D.variants.length; i++) {
      var v = D.variants[i];
      if ((ci < 0 || v.options[ci] === cor) && (si < 0 || v.options[si] === tam)) return v;
    }
    return null;
  }
  function corDisponivel(cor) { return D.variants.some(function (v) { return v.available && (ci < 0 || v.options[ci] === cor); }); }
  function fotoDaCor(cor) {
    for (var i = 0; i < D.variants.length; i++) { var v = D.variants[i]; if ((ci < 0 || v.options[ci] === cor) && v.img) return v.img; }
    return D.capa;
  }
  function menorPreco() { var m = null; D.variants.forEach(function (v) { if (v.available && (m === null || v.price < m)) m = v.price; }); return m === null ? (D.variants[0] ? D.variants[0].price : 0) : m; }
  var primeiraCor = (D.cores.filter(corDisponivel)[0]) || D.cores[0] || null;

  /* estado: modo (1 ou 3) e as peças escolhidas */
  var ativa = D.ativa && raiz.getAttribute('data-ativa') === '1';
  var st = { modo: ativa ? 3 : 1, pecas: [{ cor: primeiraCor, tam: null }, { cor: primeiraCor, tam: null }] };

  var elPecas = q('[data-fp-pecas]');
  var elCta = q('[data-fp-cta]');
  var elCtaLabel = q('[data-fp-cta-label]');
  var elErro = q('[data-fp-erro]');

  /* ---------- desenho das peças ---------- */
  function desenhaPecas() {
    var n = st.modo === 3 ? 2 : 1;
    var html = '';
    for (var i = 0; i < n; i++) {
      var p = st.pecas[i];
      html += '<div class="tp-fp__peca" data-fp-peca="' + i + '">';
      html += '<div class="tp-fp__peca-topo"><span class="tp-fp__peca-n">' + (st.modo === 3 ? 'Peça ' + (i + 1) : 'Sua peça') + '</span>';
      html += '<span class="tp-fp__peca-sel">' + (p.cor ? esc(p.cor) : '') + (p.tam ? ' · ' + esc(p.tam) : '') + '</span></div>';
      if (ci > -1 && D.cores.length > 1) {
        html += '<div class="tp-fp__cores" role="radiogroup" aria-label="Cor da peça ' + (i + 1) + '">';
        D.cores.forEach(function (cor) {
          var disp = corDisponivel(cor);
          var hex = CORES_HEX[semAcento(cor)] || '#ccc';
          html += '<button type="button" class="tp-fp__cor' + (p.cor === cor ? ' is-sel' : '') + (disp ? '' : ' is-esgotada') + '" data-fp-cor="' + esc(cor) + '" role="radio" aria-checked="' + (p.cor === cor) + '" aria-label="' + esc(cor) + (disp ? '' : ' (esgotada)') + '" title="' + esc(cor) + '">';
          html += '<span class="tp-fp__cor-bolha" style="background:' + hex + '"><img src="' + esc(D.swatches[cor] || '') + '" alt="" onerror="this.remove()"></span>';
          html += '</button>';
        });
        html += '</div>';
      }
      if (si > -1) {
        html += '<div class="tp-fp__tamanhos" role="radiogroup" aria-label="Tamanho da peça ' + (i + 1) + '">';
        D.tamanhos.forEach(function (tam) {
          var v = variante(p.cor, tam);
          var ok = v && v.available;
          html += '<button type="button" class="tp-fp__tam' + (p.tam === tam ? ' is-sel' : '') + (ok ? '' : ' is-esgotado') + '" data-fp-tam="' + esc(tam) + '" role="radio" aria-checked="' + (p.tam === tam) + '"' + (ok ? '' : ' aria-disabled="true"') + '>' + esc(tam) + '</button>';
        });
        html += '</div>';
      }
      html += '</div>';
    }
    if (st.modo === 3) {
      html += '<div class="tp-fp__peca tp-fp__peca--gratis"><div class="tp-fp__peca-topo"><span class="tp-fp__peca-n">Peça 3</span><span class="tp-fp__peca-sel tp-fp__peca-sel--gratis">Grátis</span></div>';
      html += '<p class="tp-fp__gratis-txt"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M2.9 9.4h14.2v7.2a1 1 0 0 1-1 1H3.9a1 1 0 0 1-1-1V9.4z"/><path d="M2.1 6.6h15.8v2.8H2.1z"/><path d="M10 6.6v11"/><path d="M10 6.6S8.9 2.5 6.8 2.5a1.9 1.9 0 0 0 0 4.1H10z"/><path d="M10 6.6s1.1-4.1 3.2-4.1a1.9 1.9 0 0 1 0 4.1H10z"/></svg>Assim que as duas peças entrarem no carrinho, você escolhe a cor e o tamanho da terceira. Qualquer cor, qualquer tamanho.</p></div>';
    }
    elPecas.innerHTML = html;
  }

  /* ---------- preços e textos ---------- */
  function precoPeca(i) { var p = st.pecas[i]; var v = p.tam ? variante(p.cor, p.tam) : null; if (v) return v.price; var m = null; D.variants.forEach(function (x) { if (x.available && (ci < 0 || x.options[ci] === p.cor) && (m === null || x.price < m)) m = x.price; }); return m === null ? menorPreco() : m; }
  function atualizaPrecos() {
    var p1 = precoPeca(0), p2 = precoPeca(1);
    var e1 = q('[data-fp-preco1]'); if (e1) e1.textContent = brl(st.modo === 1 ? p1 : menorPreco());
    var total3 = p1 + p2;
    var e3 = q('[data-fp-preco3]'); if (e3) e3.textContent = brl(total3);
    var d3 = q('[data-fp-de3]'); if (d3) d3.textContent = brl(total3 + Math.min(p1, p2));
    var c3 = q('[data-fp-cada3]'); if (c3) c3.textContent = brl(Math.round(total3 / 3)) + ' cada';
    /* trio: fotos das cores escolhidas; a terceira repete a primeira, apagada, com o selo */
    qa('[data-fp-trio-peca]').forEach(function (el) { var i = +el.getAttribute('data-fp-trio-peca'); var img = el.querySelector('img'); if (img) img.src = fotoDaCor(st.pecas[i].cor); });
    var g = q('.tp-fp__trio-peca--gratis img'); if (g) g.src = fotoDaCor(st.pecas[0].cor);
  }
  function faltaTamanho() { var n = st.modo === 3 ? 2 : 1; for (var i = 0; i < n; i++) { if (si > -1 && !st.pecas[i].tam) return i; var v = variante(st.pecas[i].cor, st.pecas[i].tam); if (!v || !v.available) return i; } return -1; }
  function atualizaCta() {
    var falta = faltaTamanho();
    var total = st.modo === 3 ? precoPeca(0) + precoPeca(1) : precoPeca(0);
    if (falta > -1) {
      elCtaLabel.textContent = st.modo === 3 ? 'Escolha o tamanho da peça ' + (falta + 1) : 'Escolha o tamanho';
      elCta.classList.add('is-espera');
    } else {
      elCtaLabel.textContent = (st.modo === 3 ? 'Levar 3 pagando 2 · ' : 'Adicionar ao carrinho · ') + brl(total);
      elCta.classList.remove('is-espera');
    }
  }
  function render() { desenhaPecas(); atualizaPrecos(); atualizaCta(); raiz.setAttribute('data-modo', st.modo); }

  /* ---------- galeria: foto da cor da peça 1, sem mover a página ---------- */
  function irParaFoto(cor) {
    var gal = document.querySelector('media-gallery');
    if (!gal || !cor) return;
    var v = null; for (var i = 0; i < D.variants.length; i++) { if ((ci < 0 || D.variants[i].options[ci] === cor) && D.variants[i].mediaId) { v = D.variants[i]; break; } }
    var alvo = v ? gal.querySelector('.product__media-item[data-media-id$="-' + v.mediaId + '"]') : null;
    if (!alvo) {
      var radical = semAcento(cor).replace(/o$/, '');
      var itens = [].slice.call(gal.querySelectorAll('.product__media-item[data-media-id]'));
      for (var j = 0; j < itens.length && !alvo; j++) { var img = itens[j].querySelector('img'); if (img && semAcento(img.getAttribute('alt') || '').indexOf(radical) > -1) alvo = itens[j]; }
    }
    if (!alvo) return;
    var id = alvo.getAttribute('data-media-id'), lista = alvo.parentElement;
    [].slice.call(lista.querySelectorAll('[data-media-id]')).forEach(function (el) { el.classList.remove('is-active'); });
    alvo.classList.add('is-active');
    if (lista.scrollWidth - lista.clientWidth > 8) {
      var snap = lista.style.scrollSnapType, beh = lista.style.scrollBehavior;
      lista.style.scrollSnapType = 'none'; lista.style.scrollBehavior = 'auto';
      lista.scrollLeft = alvo.offsetLeft;
      setTimeout(function () { lista.style.scrollSnapType = snap; lista.style.scrollBehavior = beh; }, 80);
    }
    var thumbs = gal.querySelector('.thumbnail-list');
    if (thumbs) {
      [].slice.call(thumbs.querySelectorAll('button')).forEach(function (b) { b.removeAttribute('aria-current'); });
      var mini = thumbs.querySelector('[data-target="' + id + '"]');
      if (mini) { var bt = mini.querySelector('button'); if (bt) bt.setAttribute('aria-current', 'true'); try { thumbs.scrollTo({ left: mini.offsetLeft, behavior: 'smooth' }); } catch (e) {} }
    }
  }

  /* ---------- eventos ---------- */
  qa('input[name="tp-fp-modo"]').forEach(function (r) {
    r.addEventListener('change', function () { if (r.checked) { st.modo = +r.value; render(); } });
  });
  elPecas.addEventListener('click', function (ev) {
    var bCor = ev.target.closest('[data-fp-cor]'), bTam = ev.target.closest('[data-fp-tam]');
    var peca = ev.target.closest('[data-fp-peca]'); if (!peca) return;
    var i = +peca.getAttribute('data-fp-peca');
    if (bCor) {
      st.pecas[i].cor = bCor.getAttribute('data-fp-cor');
      var v = variante(st.pecas[i].cor, st.pecas[i].tam); if (!v || !v.available) st.pecas[i].tam = null;
      render();
      if (i === 0) irParaFoto(st.pecas[0].cor);
    } else if (bTam && bTam.getAttribute('aria-disabled') !== 'true') {
      st.pecas[i].tam = bTam.getAttribute('data-fp-tam');
      render();
    }
  });

  elCta.addEventListener('click', function () {
    var falta = faltaTamanho();
    if (falta > -1) {
      var alvo = q('[data-fp-peca="' + falta + '"] .tp-fp__tamanhos') || q('[data-fp-peca="' + falta + '"]');
      if (alvo) { alvo.classList.add('is-pisca'); setTimeout(function () { alvo.classList.remove('is-pisca'); }, 900); alvo.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
      return;
    }
    var itens = [];
    var n = st.modo === 3 ? 2 : 1;
    for (var i = 0; i < n; i++) {
      var v = variante(st.pecas[i].cor, st.pecas[i].tam);
      var ja = itens.filter(function (it) { return it.id === v.id; })[0];
      if (ja) ja.quantity += 1; else itens.push({ id: v.id, quantity: 1 });
    }
    var rotulo = elCtaLabel.textContent;
    elCta.disabled = true; elCtaLabel.textContent = 'Adicionando...'; elErro.hidden = true;
    var gaveta = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var corpo = { items: itens };
    if (gaveta && typeof gaveta.getSectionsToRender === 'function') {
      corpo.sections = gaveta.getSectionsToRender().map(function (s) { return s.id; });
      corpo.sections_url = window.location.pathname;
    }
    /* avisa o pop-up do terceiro que a adição veio da caixa de 2 (ele abre na hora, sem esperar o próximo evento) */
    try { window.__tpFpAdicao = { modo: st.modo, ts: Date.now() }; } catch (e) {}
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(corpo)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res && res.status) throw new Error(res.description || res.message || 'Não foi possível adicionar.');
      if (gaveta && typeof gaveta.renderContents === 'function') { if (gaveta.classList.contains('is-empty')) gaveta.classList.remove('is-empty'); gaveta.renderContents(res); }
      if (gaveta && typeof gaveta.open === 'function') gaveta.open();
    }).catch(function (err) {
      elErro.textContent = (err && err.message) || 'Não foi possível adicionar. Tente de novo.'; elErro.hidden = false;
    }).finally(function () { elCta.disabled = false; elCtaLabel.textContent = rotulo; atualizaCta(); });
  });

  /* ---------- tabela de medidas ---------- */
  var sg = q('[data-fp-sg]');
  if (sg) {
    if (sg.parentElement !== document.body) document.body.appendChild(sg); /* fixed dentro de ancestral com transform quebra; vai para o body */
    var abrirSg = function () { sg.setAttribute('aria-hidden', 'false'); sg.classList.add('is-open'); document.documentElement.classList.add('tp-fp-sg-aberto'); };
    var fecharSg = function () { sg.setAttribute('aria-hidden', 'true'); sg.classList.remove('is-open'); document.documentElement.classList.remove('tp-fp-sg-aberto'); };
    var bo = q('[data-fp-sg-open]'); if (bo) bo.addEventListener('click', abrirSg);
    sg.addEventListener('click', function (ev) { if (ev.target === sg || ev.target.closest('[data-fp-sg-close]')) fecharSg(); });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && sg.classList.contains('is-open')) fecharSg(); });
  }

  render();
})();
